import objectHash from "object-hash";
import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import biApi from "../../../../../../../../api/biApi";
import { createCurrentReportAction } from "../../../../store/utils/storeUtils";
import useDimensionAndMeasuresSelection from "./useDimensionAndMeasuresSelection";
import type { CancellationToken, LedgerBasisRequest } from "../../../../../../../../api/types/svTypes.ts";

const useLedgerBasis = () => {
  const dispatch = useDispatch();
  const cancellationRef = useRef<CancellationToken>(undefined);
  const { dimensionNames, measureNames } = useDimensionAndMeasuresSelection();

  const dimensionHash = objectHash(dimensionNames);
  const measureHash = objectHash(measureNames);

  useEffect(() => {
    if (cancellationRef.current) {
      cancellationRef.current.cancel();
    }
    if (dimensionNames.length === 0 && measureNames.length === 0) {
      return;
    }
    const body: LedgerBasisRequest = {
      dimensionNames,
      measureNames,
    };
    cancellationRef.current = biApi.getLedgerBasis(
      body,
      (resp) => {
        if (resp.success && resp.data) {
          dispatch(createCurrentReportAction("updateIsReportTransactional", resp.data.transactional));
        }
      },
      () => {
        //TODO: nothing
      }
    );
    // eslint-disable-next-line @eslint-react/exhaustive-deps
  }, [dimensionHash, measureHash]);
};

export default useLedgerBasis;
